export type SortState = {
  sortColumnIndex: number;
  sortDirection: string;
};

export type FilterData = {
  order?: {
    field: string;
    direction?: string;
  };
  searchKeyword?: string;
  productStatus?: string;
};

export type SortConfig = {
  sortColumnIndex: number;
  sortDirection: string;
  onSort: (idx: number, direction: string) => void;
};

export type FilterConfig = {
  filterData: FilterData;
  onFilter: (filter: FilterData) => void;
};

export type SyncConfig = {
  isSync: boolean;
  lastTimesSync?: string | boolean;
  onSyncProduct: () => void;
};

export type LoadingState = {
  isLoading: boolean;
  isSuccess: boolean;
  isEmpty: boolean;
};

export type PaginationConfig = {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  onFetchNextPage: () => void;
};

export enum SelectionModeType {
  SINGLE = 'SINGLE',
  MULTIPLE = 'MULTIPLE',
}

export enum MappingKeyProduct {
  ID = 'id',
}
